import { useRef } from 'react';
import Character from './Character';

export default function Hero() {
  const heroRef = useRef(null);

  return (
    <section id="top" className="lw-section lw-hero" ref={heroRef}>
      <div className="lw-hero__text">
        <p className="lw-mono">INDIE APP STUDIO · SINCE 2026</p>

        <h1 className="lw-h1 lw-hero__title">
          작은 승리를<br />만듭니다.
        </h1>

        <p className="lw-sub lw-hero__sub">
          1인 가구의 삶이 조금 더 윤택해지도록, 일상의 불편을 게임처럼 푸는
          작은 앱을 만듭니다.
        </p>

        <div className="lw-cta lw-hero__cta">
          <a className="lw-btn lw-btn--solid" href="#projects">만든 것 보기</a>
          <a className="lw-btn lw-btn--ghost" href="#contact">연락하기</a>
        </div>
      </div>

      <div className="lw-hero__visual">
        <Character trackRef={heroRef} />
      </div>
    </section>
  );
}
